import react from 'react'; // eslint-disable-line
import { graphql, useStaticQuery } from 'gatsby';
import { FaqItem } from '../gatsby/types/faq-item';

export type FaqsData = {
  faqs: {
    edges: {
      node: FaqItem;
    }[]
  }
}

export const useFaqsTranslations = (
): FaqItem[] => {
  const { faqs } = useStaticQuery<FaqsData>(graphql`
    query {
      faqs: allStrapiFaQsTranslations {
        edges {
          node {
            id
            title
            description
            category
            pageUrl
            featured
          }
        }
      }
    }
  `);

  return faqs.edges.map(({ node }) => node);
};
